import { Fragment } from "react";
import { Reveal } from "@/components/motion/Reveal";

// Animated connector with a travelling particle. Horizontal on desktop, vertical on phones.
const Connector = ({ label }) => (
  <div className="relative flex items-center justify-center py-2 xl:flex-1 xl:py-0" aria-hidden="true">
    <div className="relative h-14 w-px overflow-hidden bg-line xl:h-px xl:w-full">
      <span className="absolute left-1/2 top-0 h-3 w-[3px] -translate-x-1/2 bg-accent animate-[travel-y_2.4s_linear_infinite] xl:left-0 xl:top-1/2 xl:h-[3px] xl:w-6 xl:-translate-y-1/2 xl:translate-x-0 xl:animate-[travel-x_2.4s_linear_infinite]" />
    </div>
    {label && (
      <span className="absolute left-[calc(50%+14px)] z-20 whitespace-nowrap border border-line bg-paper px-2 py-1 font-mono text-[12px] uppercase tracking-[0.04em] text-muted xl:left-1/2 xl:top-auto xl:-translate-x-1/2 xl:-translate-y-8">
        {label}
      </span>
    )}
  </div>
);

const Node = ({ n, i }) => {
  const isSpc = n.id === "spc";
  return (
    <div
      className={`relative z-10 w-full max-w-md border p-6 text-center xl:w-[200px] xl:shrink-0 ${
        isSpc ? "spec-corners border-accent bg-accent text-accent-ink [&::before]:border-ink [&::after]:border-ink" : "border-line bg-surface text-ink"
      }`}
      data-testid={`deal-node-${n.id}`}
    >
      <span className={`font-mono text-[12px] ${isSpc ? "opacity-80" : "text-muted"}`}>{String(i + 1).padStart(2, "0")}</span>
      <p className="mt-2 font-display text-2xl font-semibold tracking-[-0.03em]">{n.title}</p>
      <p className={`mt-2 text-[14px] leading-snug ${isSpc ? "opacity-90" : "text-muted"}`}>{n.body}</p>
    </div>
  );
};

export const DealFlow = ({ flow = [] }) => (
  <Reveal className="border border-line bg-paper p-6 sm:p-10 lg:p-14" data-testid="deal-flow-diagram">
    <div className="flex flex-col items-center xl:flex-row xl:items-stretch">
      {flow.map((n, i) => (
        <Fragment key={n.id}>
          <Node n={n} i={i} />
          {i < flow.length - 1 && <Connector label={n.link} />}
        </Fragment>
      ))}
    </div>
  </Reveal>
);
